var _polygon, _path, _polygon2, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polyline, _rect5, _polygon3, _rect6, _rect7, _rect8, _rect9, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect10, _path19, _path20, _polygon4, _polygon5, _path21, _rect11, _polygon6, _path22, _path23, _path24, _polygon7, _polygon8, _path25, _path26, _rect12, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _path42, _path43, _ellipse, _polygon9, _polygon10, _path44, _polygon11, _rect79, _path45, _ellipse2, _path46, _path47, _path48, _polygon12, _polygon13, _path49, _path50, _path51, _path52, _path53, _path54, _rect80, _path55, _path56, _path57, _polygon14, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAusbildungProg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "388.01 594.19 388.55 597.34 420.69 588.57 418.44 575.5 388.01 594.19",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M388.55,597.34s.48,16.78,2.17,31.52l114.22-18.33s2.57-4.39-3.62-7.27c-1.39-.63-2.87-1.02-4.39-1.15-18.86-1.97-37.52-5.57-55.75-10.76-7.46-2.12-14.55-4.43-21.24-6.86l.7,4.09-32.1,8.77Z",
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "390.73 628.86 392.28 634.7 506 615.2 504.95 610.53 390.73 628.86",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108.07,
    y: 42.38,
    width: 432.42,
    height: 300.3,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 388.77,
    y: 134.63,
    width: 79.09,
    height: 183.04,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 172.48,
    y: 150.2,
    width: 106.98,
    height: 167.47,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 279.47,
    y: 76.87,
    width: 109.3,
    height: 240.81,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,134.79h-87.02v-3.23h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59h0v.04Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,154.52h-87.02v-3.15h87.02c.87,0,1.57,.71,1.57,1.59h0c-.02,.86-.72,1.56-1.57,1.55Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,174.75h-87.02v-3.19h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,196.18h-87.02v-3.19h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,215.96h-87.02v-3.19h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,236.83h-87.02v-3.19h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,258.58h-87.02v-3.19h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,279.33h-87.02v-3.19h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M475.73,298.88h-87.02v-3.19h87.02c.87,0,1.57,.71,1.57,1.59h0c0,.88-.7,1.59-1.57,1.59Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "493.55 106.7 493.55 225.84 449.14 225.84",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 470.77,
    y: 78.87,
    width: 46.41,
    height: 28.01,
    rx: 2.94,
    ry: 2.94,
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "297.01 510.42 290.73 496.69 241.12 481.7 228.35 496.69 238.47 506.62 297.01 510.42",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 506.11,
    y: 405.16,
    width: 11.83,
    height: 218.41,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 506.11,
    y: 405.16,
    width: 4.08,
    height: 218.41,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 320.52,
    y: 406.41,
    width: 11.83,
    height: 218.41,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 320.52,
    y: 406.41,
    width: 4.08,
    height: 218.41,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M241.12,490.59s62.19,19.06,91.54-1.57l47.33,108.71,55.05-22.34-33.77-84.65v-7.64l33.77,53.6,45.56-31.8s-47.75-85.81-79.32-96.92c0,0-11.95-6.05-35.27-2.84l-94.29,13.14-30.6,27.21v45.09Z",
    fill: "#EC1C24",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M659.27,587.67l1.88,35.9h81.68c7.43,0,9.73-10.04,3.05-13.29-3.46-1.69-7.77-3.3-13.11-4.66,0,0-25.73-4.25-25.51-21.46l-47.99,3.51Z",
    fill: "#EC1C24",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M643.71,587.67l-1.88,35.9h-81.68c-7.43,0-9.73-10.04-3.05-13.29,3.46-1.69,7.77-3.3,13.11-4.66,0,0,25.72-4.25,25.51-21.46l47.99,3.51Z",
    fill: "#EC1C24",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M665.31,587.23s5.84,23.21,30.07-2.19l-30.07,2.19Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M637.63,587.23s-5.84,23.21-30.09-2.19l30.09,2.19Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M714.36,440.21c1.1,28.5-2.59,75.51-2.59,75.51-4.44,28.5,0,68.11,0,68.11l-55.91,4.08v-87.74c-.36-69.59-4.81-93.29-4.81-93.29l-3.71,181.03-57.68-2.23,.31-126.24c-2.23-66.64,8.14-144.92,8.14-144.92l89.96-7.59,26.47,21.51-.18,111.76Z",
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M748.05,278.06c-7.04,10.74-30.73,31.83-30.73,31.83l-53.5,10.74c-17.21,3.33-33.49-3.33-33.49-3.33l-38.49-85.51-33.32,7.77c-32.21,8.89-45.53-2.23-45.53-2.23l-58.86-34.43,16.66-30.29,63.29,22.89,71.15-35.24c18.72-13.06,42.87-10.29,42.87-10.29,0,0,23.52,.74,31.47,2.03,5.38,.88,9.56,1.92,11.66,2.5,1.02,.3,2.01,.74,2.92,1.3l30.53,18.28c8.88,10.73,31.83,74.03,31.83,74.03,5.25,17.35-8.45,29.93-8.45,29.93Z",
    fill: "#EC1C24",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M679.56,152.01c-.81,13.17-12.5,12.48-13.11,12.75h0c-16.48,1.67-18.33-14.8-18.33-14.8,8.15-3.71,5.73-14.03,5.73-14.03l25.99-10.83-.21,16.68h0l-.07,10.23Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 635.36,
    y: 74.29,
    width: 50.11,
    height: 66.07,
    rx: 25.05,
    ry: 25.05,
    transform: "translate(58.49 -184.82) rotate(16.66)",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M638.47,149.99l-3.34,66.99-3.89,111.43-36.41-2.33-4.22-.27,2.28-48.99c.93-9.88,.78-19.83-.44-29.68-.23-1.88-.39-3.76-.45-5.65-.14-4.2,.12-8.4,.78-12.56,3.89-24.73,14.6-70.1,14.6-70.1,9.44-5.54,20.15-8.59,31.1-8.84Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M720.46,328.45h-58.49l5.55-69.02,.51-6.21,3.02-37.47c.67-13.07,18.94-52.85,22.39-60.26,.32-.68,1.1-1.02,1.81-.78,6.73,2.44,13.29,5.35,19.62,8.71,8.89,3.47,9.86,10.69,9.86,10.69l-8.89,51.83c-4.81,46.2,4.63,102.51,4.63,102.51Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "665.44 285.38 715.48 282.55 716.45 295.03 664.39 298.31 665.44 285.38",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "664.04 302.68 716.86 299.62 718.16 311.86 663.04 315.13 664.04 302.68",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M672.73,101.8s2.14,12.99,2.66,19.94c.1,1.32,1.15,2.37,2.47,2.48l10.64,.89c4.25-2.51,9.26-10.04,10.03-14.91l-25.8-8.4Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 639.9,
    y: 405.16,
    width: 6.53,
    height: 236.91,
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.41 389.18 329.11 390.79 329.11 379.38 387.41 379.38 387.41 389.18",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M169.57,303.61s-26.51,29.8-16.25,74.22l17.62,87.06c1.18,5.85,.4,11.92-2.23,17.27l-2.33,4.79,72.45,12.18s6.09-24.54,12.49-41.01l4.46-35.06s-3.89-19.27-11.23-42.5l-9.6-30.8s-2.23-23.57-24.42-32.48c0,.03-22.48-11.53-40.96-13.67Z",
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M396.07,477.11l-13.49-27.78c-3.08-6.34-9.1-10.73-16.07-11.72l-34.34-4.91",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M553.66,522.06c-2.17-7.58-11.35-9.86-27.07-8.15-2.41,.26-4.84,.38-7.27,.29-9.9-.39-34.54-2.08-38.73-9.33l-41.89,29.24s2.31,7.44,4.06,22.48l100.06-31.28,10.83-3.25Z",
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "203.37 511.18 165.25 659.44 304.4 659.44 292.26 519.68 285.57 518.02 297.41 654.27 173.46 654.27 209.92 511.18 203.37 511.18",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.44 492.32 140.33 640.6 279.48 640.6 267.95 505.47 261.26 503.83 272.48 635.43 148.53 635.43 184.99 492.32 178.44 492.32",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M646.43,379.38H372.48c1.93-40.32-12.96-40.85-12.96-40.85l24.72,.76h0l65.59,2.03c42.95,1.74,124.26-1.44,161.66-3.1,12.21-.54,19.73-.93,19.73-.93,21.68,23.72,15.2,42.08,15.2,42.08Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M611.47,338.23l-108.06,23.63-119.2-22.57,65.59,2.03c42.96,1.74,124.27-1.44,161.67-3.1Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 108.07,
    y: 23.45,
    width: 432.42,
    height: 21.09,
    fill: "#EC1C24",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M170.54,147.01h108.93v3.19h-108.93c-.88,0-1.59-.71-1.59-1.59h0c0-.88,.71-1.59,1.59-1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,80.47h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,108.52h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,134.89h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,162.38h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,189.15h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,217.15h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,244.64h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,272.54h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,300.06h-111.23v-3.19h111.23c.88,0,1.59,.71,1.59,1.59h0c0,.88-.71,1.59-1.59,1.59Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M170.54,176.81h108.93v3.19h-108.93c-.88,0-1.59-.71-1.59-1.59h0c0-.88,.71-1.59,1.59-1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M170.54,206.43h108.93v3.19h-108.93c-.88,0-1.59-.71-1.59-1.59h0c0-.88,.71-1.59,1.59-1.59Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M170.54,235.3h108.93v3.19h-108.93c-.88,0-1.59-.71-1.59-1.59h0c0-.88,.71-1.59,1.59-1.59Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M170.54,268.94h108.93v3.19h-108.93c-.88,0-1.59-.71-1.59-1.59h0c0-.88,.71-1.59,1.59-1.59h0Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M170.54,298.06h108.93v3.19h-108.93c-.88,0-1.6-.7-1.61-1.58,0-.03,0-.05,0-.08h0c.03-.86,.75-1.54,1.61-1.53Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 180.43,
    y: 157.69,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 199.69,
    y: 157.69,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 219.48,
    y: 157.69,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 238.86,
    y: 157.69,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 258.02,
    y: 157.69,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 288.4,
    y: 89.43,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 307.67,
    y: 89.43,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 327.46,
    y: 89.43,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 346.83,
    y: 89.43,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 366.01,
    y: 89.43,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 289.6,
    y: 116.91,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 308.88,
    y: 116.91,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 328.66,
    y: 116.91,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 348.04,
    y: 116.91,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 367.21,
    y: 116.91,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 289.6,
    y: 144.07,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 308.88,
    y: 144.07,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 328.66,
    y: 144.07,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 348.04,
    y: 144.07,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 367.21,
    y: 144.07,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 288.65,
    y: 171.15,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 307.92,
    y: 171.15,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 327.71,
    y: 171.15,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 347.09,
    y: 171.15,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 366.25,
    y: 171.15,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 288.65,
    y: 198.89,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 307.92,
    y: 198.89,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 327.71,
    y: 198.89,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 347.09,
    y: 198.89,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 366.25,
    y: 198.89,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 288.65,
    y: 225.03,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 307.92,
    y: 225.03,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 327.71,
    y: 225.03,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 347.09,
    y: 225.03,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 366.25,
    y: 225.03,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 288.9,
    y: 253.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 253.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 327.97,
    y: 253.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 347.34,
    y: 253.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 366.51,
    y: 253.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 288.9,
    y: 280.22,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 308.18,
    y: 280.22,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 327.97,
    y: 280.22,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 347.34,
    y: 280.22,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 366.51,
    y: 280.22,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 180.67,
    y: 188.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 199.95,
    y: 188.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 219.74,
    y: 188.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 239.11,
    y: 188.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 258.28,
    y: 188.73,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 180.67,
    y: 217.98,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 199.95,
    y: 217.98,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 219.74,
    y: 217.98,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 239.11,
    y: 217.98,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 258.28,
    y: 217.98,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 180.93,
    y: 249.23,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 200.21,
    y: 249.23,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 249.23,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 239.37,
    y: 249.23,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 258.54,
    y: 249.23,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 180.93,
    y: 280.34,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 200.21,
    y: 280.34,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 280.34,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 239.37,
    y: 280.34,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 258.54,
    y: 280.34,
    width: 11.32,
    height: 11.32,
    rx: 1.02,
    ry: 1.02,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 157.73,
    y: 81.09,
    width: 46.41,
    height: 28.01,
    rx: 2.94,
    ry: 2.94,
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M662.85,60.68c9.61-2.06,18.14,1.83,24.27,6.14,3.29,2.33,6.28,5.04,8.93,8.09,.41,.46,.84,.89,1.3,1.3,8.46,7.54,6.41,25.02,5.38,31.52-.28,1.66-1.86,2.77-3.51,2.49,0,0,0,0-.01,0-4.83-1.06-9.59-2.43-14.25-4.08-10.62-3.56-22.18-8.03-22.18-8.03l-26.38-15.33c3.66-16.89,26.47-22.09,26.47-22.09Z",
    fill: "#EC1C24",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M626.58,94.37s-6.52-.99-5.32-5.21c.24-.86,.8-1.59,1.49-2.17,2.24-1.86,8.57-6.37,14.92-4.11,.35,.13,.69,.31,1,.52l25.16,15.03s-11.96,2.33-37.24-4.07Z",
    fill: "#EC1C24",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 682.65,
    cy: 122.45,
    rx: 7.48,
    ry: 6.5,
    transform: "translate(305.59 704.55) rotate(-67.24)",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "592.58 282.55 632.81 282.55 632.45 293.04 592.1 293.04 592.58 282.55",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "591.79 299.62 632.22 299.62 631.94 307.47 591.45 306.94 591.79 299.62",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M467.85,177.92s-5.29-18.67-18.71-19.21c0,0-12.05-1.37-16.16-3.01l-5.48-1.52c-1.03-.29-2.09,.3-2.39,1.32-.05,.18-.08,.36-.07,.54h0c0,.65,.33,1.25,.87,1.61,2.29,1.54,8.86,5.51,15.9,6.2,.32,.03,.49,.39,.29,.65-2.04,2.56-9.78,12.89-6.92,18.85,0,0,2.2,5.62,1.98,8.32-.04,.27,.12,.54,.38,.63,1.17,.41,4.15,.75,3.24-7.11,.02-.05,.08-.08,.13-.06,.03,.01,.05,.03,.06,.06,1.11,2.02,5.91,9.19,17.74,9.45l9.15-16.71Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.49 279.65 184.49 295.54 214.46 305.94 214.46 285.95 194.07 268.98 184.49 279.65",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 189.2,
    y: 226.92,
    width: 49.82,
    height: 63.9,
    rx: 24.91,
    ry: 24.91,
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M163.32,262.33s16.42,21.91,21.17,21.91h0c6.47-4.01,11.22-10.27,13.35-17.58l2.43-8.35s8.32,2.37,12.7-7.85c.53,2.03,.53,4.16,0,6.19,0,0,12.41-1.8,9.86-16.04,0,0-23.83,9.07-31.63,8.8,0,0-13.82,10.02-27.88,12.92Z",
    fill: "#002346",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.44,
    cy: 267.33,
    rx: 6.76,
    ry: 7.99,
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M234.34,222.54l-11.51,18.14c-26.83,9.3-31.63,8.81-31.63,8.81-3.4,2.5-7,4.7-10.78,6.58h0c-5.42,2.77-11.15,4.89-17.08,6.31-4.37,1.22-5.75-4.96-6.19-8.6-.22-1.84-.53-3.65-.87-5.47-3.32-17.45,7.18-29.45,12.96-34.58,1.13-1.02,2.32-1.97,3.58-2.82,0,0,32.46-23.61,61.52,11.64Z",
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M192.44,249.38c-.27,.02-.37-.34-.13-.46,1.9-.96,6.19-3.55,12.56-9.8,1.57-1.55,3.06-3.17,4.46-4.87,6.24-7.34,15.37-11.6,25.01-11.66,0,0,20.07,4.2,16.23,6.93,0,0-9.3,5.18-27.74,11.14,0-.04-21.83,8.11-30.39,8.73Z",
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M169.57,303.61s5.88-10.91,14.93-9.47c0,0,30.31,4.82,32.99,14.12,.73,3.49,2.54,6.67,5.18,9.07,0,0,15.88,11.6,26.16,41.58,0,0,16.84,43.43,22.29,57.24,.5,1.26,.75,2.6,.75,3.95v7.1l-16.09-4.16s-5.56-28.04-13.33-48.32l-7.5-24.98s-3.33-24.71-24.42-32.48c-12.98-6.36-26.75-10.95-40.94-13.66Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.74 642.07 394.74 389.18 652.12 389.18 652.12 642.07 646.42 642.07 646.42 405.16 401.27 405.16 401.27 642.07 394.74 642.07",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "389.41 399.61 329.11 399.61 329.11 390.79 387.41 389.18 394.74 389.18 394.74 642.07 390.12 642.07 389.41 399.61",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M279.47,428.45s-.47-32.08,38.07-73.3c20.54,5.37,41.4,9.43,62.45,12.15,0,0-33.61,26.57-52.55,53.59l-14.02,18.85-33.95-11.3Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M379.99,367.3s-16.49,4.12-26.59,2.68c0,0-12.68,31.36-20.73,43.91-.01,0,22.97-28.04,47.32-46.59Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M315.8,430.95c.05,.82-.03,1.64-.22,2.44-.14,.63-.31,1.26-.53,1.87-.19,.51-.26,1.06-.22,1.61,.21,2.68,.51,11.52-4.48,14.74,0,0-3.32,1.93-4.04,4-.24,.81-.83,1.47-1.62,1.78-.76,.25-1.55,.37-2.35,.36-1.99-.05-3.96-.39-5.84-1.02-.84-.25-1.71-.4-2.59-.44l-14.8-.73v-20.25c.65-1.89,.31-3.99-.91-5.57,0,0,9.56-10.29,17.04-11.34h0c2.65-.54,5.34,.75,6.58,3.15,.89,1.6,2.22,2.91,3.82,3.8,.41,.23,.85,.42,1.3,.57,.9,.28,1.83,.42,2.77,.39,1.67-.01,5.86,.38,6.09,4.65Z",
    fill: "#f1b2c0",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M455.64,166.27l-15.8,3.95c-1.15,.29-1.72,1.59-1.15,2.63,.94,1.7,3.79,3.57,12.17,2.48,.91-.12,1.82,.39,2.15,1.25,.21,.58,.36,1.32,.25,2.24-.13,1.16,0,2.36,.5,3.41,.8,1.65,2.58,3.41,6.56,3.07",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M437.77,176.56s1.55,6.22,3.61,9.1c.79,1.11,2.55,.99,3.1-.26,0,0,1.26-1.07-.56-3.87",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M441.02,175.47s2.17,7.58,5.42,7.58c0,0,3.74,.55,1.87-7.31",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 387.41,
    y: 379.38,
    width: 274.57,
    height: 9.8,
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M279.64,461.4l-40.78-4.72c-1.08-.12-2.12-.25-3.15-.4-28.64-3.54-36.28-19.31-36.28-19.31-1.8-3.17-4.2-8.16-6.75-13.73h0c-6.83-14.91-14.68-34.05-14.68-34.05-11.1-43.07,6.48-54.11,6.48-54.11,20.06-16.11,29.97,9.72,29.97,9.72,8.66,16.39,21.33,65.25,21.33,65.25,1.67,8.6,6.1,8.89,6.1,8.89l37.76,7.81v34.66Z",
    fill: "#243E59",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M136.14,378.01s6.48-7.77,17.18-.18c0,0,13.8,17.53,27.3,17.56,0,0,3.77-1.36,8.02,11.03l21.59,76.69s2.42,14.37,34.63,16.05c0,0,63.9,3.55,53.37,18.87l-84.02-9.58-78.06-130.44Z",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M298.63,520.27c-.42,1.5-1.87,2.47-3.42,2.29l-79.93-6.94c-24.83-2.93-29.07-7.77-29.07-7.77-7-6.39-25.91-51.55-25.91-51.55-10.76-22.27-19.69-45.36-26.72-69.07-1.52-23.39,24.31,1.97,24.31,1.97,0,0,3.89,4.42,13.67,6.21,0,0,10.94,.54,14.89,18.52l19.55,71.44s.71,12.74,19.44,15.64c.09-.01,75.93,7.35,73.21,19.28Z",
    fill: "#e6e7e8",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "442.76 556.59 443.18 562.13 554.74 526.39 553.66 522.06 442.76 556.59",
    fill: "#fff",
    stroke: "#002346",
    strokeMiterlimit: 10
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "204.68 94.32 232.53 98.03 232.53 146.77",
    fill: "none",
    stroke: "#002346",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusbildungProg);
export default __webpack_public_path__ + "static/media/ausbildung-prog.7af3fc0eab54ad86a78b92b055ee00e9.svg";
export { ForwardRef as ReactComponent };